/* Rey Vinilo · calculadora de metros (sections/rv-calculadora.liquid).
   Coloca las piezas en un rollo de 152 cm (estanterías, la más larga primero), suma el largo
   y recomienda la medida del rollo. Medidas habituales de cada pieza en cm (ancho × largo, sin sobrante)
   por tamaño: utilitario, compacto, berlina o familiar, SUV o monovolumen, furgoneta. */
(function () {
  var root = document.querySelector('[data-rv-calc]');
  if (!root) return;
  var D = JSON.parse(document.querySelector('[data-rv-calc-data]').textContent);
  var T = D.t, W = 152, M = 20; /* ancho del rollo y sobrante (10 cm por lado) */
  var PIEZAS = {
    roof:    { n: 'Techo', s: [[125, 160], [130, 170], [130, 210], [130, 250], [150, 330]] },
    hood:    { n: 'Capó', s: [[120, 95], [130, 105], [140, 110], [145, 120], [150, 110]] },
    trunk:   { n: 'Maletero', s: [[110, 80], [120, 90], [125, 100], [130, 110], [150, 130]] },
    door:    { n: 'Puerta', s: [[100, 85], [110, 90], [115, 95], [120, 100], [140, 110]] },
    bumperf: { n: 'Paragolpes del.', s: [[170, 45], [175, 50], [180, 50], [185, 55], [195, 55]] },
    bumperr: { n: 'Paragolpes tras.', s: [[170, 45], [175, 50], [180, 50], [185, 55], [195, 55]] },
    mirrors: { n: 'Retrovisor', q: 2, s: [[30, 20], [32, 22], [32, 22], [35, 25], [40, 30]] },
    spoiler: { n: 'Alerón', s: [[100, 25], [110, 30], [120, 30], [120, 30], [140, 30]] },
    chrome:  { n: 'Chrome delete', fix: [W, 90] },
    interior:{ n: 'Molduras interior', fix: [W, 50] },
    badges:  { n: 'Emblemas', fix: [40, 15] },
    moto:    { n: 'Moto completa', fix: [W, 250] },
    tank:    { n: 'Depósito', fix: [55, 50] },
    helmet:  { n: 'Casco', fix: [50, 45] },
    housedoor: { n: 'Puerta de casa', fix: [85, 205] }
  };
  var FULL = [1500, 1500, 1700, 1900, 2500], FRAMES = 250;
  var size = 1, nc = 0, hasRes = false, resVisible = false;
  /* Barra del móvil: sale cuando hay resultado y el recuadro del resultado no se ve */
  function bar() { var b = root.querySelector('[data-bar]'); if (b) b.classList.toggle('is-on', hasRes && !resVisible); }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { resVisible = e[0].isIntersecting; bar(); }).observe(root.querySelector('.rv-calc__res'));
  }
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };

  function pieces() {
    var out = [], seam = false;
    function add(name, w, l, q, raw) {
      w = +w; l = +l; q = Math.max(1, Math.min(50, +q || 1));
      if (!(w > 0 && l > 0)) return;
      if (!raw) { w += M; l += M; }
      /* que el lado más largo vaya a lo ancho si cabe (gasta menos largo) */
      var a = Math.max(w, l), b = Math.min(w, l);
      if (a <= W) { w = a; l = b; } else if (b <= W) { w = b; l = a; }
      else { seam = true; var k = Math.ceil(b / W); w = Math.ceil(b / k); l = a; q *= k; }
      for (var i = 0; i < q; i++) out.push({ n: name, w: w, l: l });
    }
    var full = $('.rv-calc__part input[value=full]').checked;
    $$('.rv-calc__part input:checked').forEach(function (c) {
      var id = c.value, p = PIEZAS[id];
      if (!p || (full && p.s)) return; /* con el coche completo, las piezas de fuera ya van incluidas */
      var d = p.fix || p.s[size];
      var q = id === 'door' ? +$('[data-qty=door]').value : (p.q || 1);
      add((T.pn && T.pn[id]) || p.n, d[0], d[1], q, p.fix && d[0] === W);
    });
    $$('[data-custom] .rv-calc__row').forEach(function (r, i) {
      var v = $$('input', r).map(function (x) { return x.value; });
      add(T.piece + ' ' + (i + 1), v[1], v[0], v[2]);
    });
    return { list: out, seam: seam };
  }

  /* Estanterías: piezas de más largas a más cortas; cada una en la primera estantería donde quepa a lo ancho */
  function pack(list) {
    list = list.slice().sort(function (a, b) { return b.l - a.l || b.w - a.w; });
    var shelves = [], y = 0;
    list.forEach(function (p) {
      for (var i = 0; i < shelves.length; i++) {
        var s = shelves[i];
        if (s.used + p.w <= W && p.l <= s.h) { p.x = s.y; p.y = s.used; s.used += p.w; return; }
      }
      shelves.push({ y: y, h: p.l, used: p.w });
      p.x = y; p.y = 0; y += p.l;
    });
    return { list: list, len: y };
  }

  function fmtLen(cm) {
    if (cm < 100) return Math.round(cm) + ' ' + T.cm;
    return (Math.round(cm / 10) / 10).toString().replace('.', T.dec || ',') + ' ' + T.m;
  }

  function recommend(need) {
    var rolls = D.rolls.map(function (r) { return r.cm; }).sort(function (a, b) { return a - b; });
    var max = rolls[rolls.length - 1], combo = [];
    while (need > max) { combo.push(max); need -= max; }
    for (var i = 0; i < rolls.length; i++) if (rolls[i] >= need) { combo.push(rolls[i]); break; }
    return combo;
  }
  function roll(cm) { for (var i = 0; i < D.rolls.length; i++) if (D.rolls[i].cm === cm) return D.rolls[i]; return {}; }

  function draw(res, total) {
    var L = Math.max(total, 1), ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + L + ' ' + W);
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', T.width);
    var bg = document.createElementNS(ns, 'rect');
    bg.setAttribute('width', L); bg.setAttribute('height', W); bg.setAttribute('class', 'rv-calc__rbg');
    svg.appendChild(bg);
    var fs = Math.max(9, Math.min(16, L / 40));
    res.list.forEach(function (p) {
      var g = document.createElementNS(ns, 'g');
      var r = document.createElementNS(ns, 'rect');
      r.setAttribute('x', p.x + 1.5); r.setAttribute('y', p.y + 1.5);
      r.setAttribute('width', Math.max(p.l - 3, 1)); r.setAttribute('height', Math.max(p.w - 3, 1));
      r.setAttribute('rx', 3); r.setAttribute('class', 'rv-calc__pc');
      g.appendChild(r);
      if (p.l > fs * 3 && p.w > fs * 1.6) {
        var t = document.createElementNS(ns, 'text');
        t.setAttribute('x', p.x + p.l / 2); t.setAttribute('y', p.y + p.w / 2);
        t.setAttribute('font-size', fs); t.setAttribute('text-anchor', 'middle'); t.setAttribute('dominant-baseline', 'middle');
        t.textContent = p.l * 0.55 / fs < p.n.length ? p.n.slice(0, Math.max(3, Math.floor(p.l * 0.55 / fs))) + '…' : p.n;
        g.appendChild(t);
      }
      var tt = document.createElementNS(ns, 'title');
      tt.textContent = p.n + ' · ' + p.l + ' × ' + p.w + ' cm';
      g.appendChild(tt);
      svg.appendChild(g);
    });
    var box = $('[data-roll]');
    box.innerHTML = '';
    box.appendChild(svg);
    var lab = document.createElement('div');
    lab.className = 'rv-calc__axis';
    lab.innerHTML = '<span>0</span><span>' + fmtLen(total) + '</span>';
    box.appendChild(lab);
    var wl = document.createElement('div');
    wl.className = 'rv-calc__wlab';
    wl.textContent = T.width;
    box.appendChild(wl);
  }

  function update() {
    var full = $('.rv-calc__part input[value=full]').checked;
    $('[data-full-opt]').hidden = !full;
    var r = pieces();
    var res = pack(r.list);
    var need = res.len + (full ? FULL[size] + ($('[data-frames]').checked ? FRAMES : 0) : 0);
    var has = need > 0;
    $('[data-empty]').hidden = has;
    hasRes = has;
    bar();
    $('[data-out]').hidden = !has;
    if (!has) return;
    if ($('[data-first]').checked) need = Math.ceil(need * 1.1 / 5) * 5;
    var combo = recommend(need), sum = combo.reduce(function (a, b) { return a + b; }, 0);
    $('[data-need]').textContent = fmtLen(need);
    $('[data-bar-need]').textContent = fmtLen(need);
    var names = {};
    combo.forEach(function (c) { names[c] = (names[c] || 0) + 1; });
    $('[data-rec]').textContent = Object.keys(names).sort(function (a, b) { return b - a; }).map(function (c) {
      return (names[c] > 1 ? names[c] + ' × ' : '') + fmtLen(+c);
    }).join(' ' + T.plus + ' ');
    var std = combo.length === 1 ? roll(combo[0]) : null;
    $('[data-price]').textContent = std && std.p ? std.p + (std.icr ? ' · ' + T.icr + ' ' + std.icr : '') : '';
    var left = sum - need;
    $('[data-left]').textContent = left >= 10 ? T.left.replace('{x}', fmtLen(left)) : '';
    var notes = [];
    if (r.seam) notes.push(T.seam);
    if (combo.length > 1) notes.push(T.big);
    notes.push(T.spare);
    $('[data-note]').textContent = notes.join(' ');
    if (res.len > 0) { $('[data-roll]').hidden = false; draw(res, Math.max(res.len, 1)); }
    else $('[data-roll]').hidden = true;
    $('[data-roll]').previousElementSibling.hidden = res.len === 0;
    /* productos en la medida recomendada (la mayor si son varios rollos) */
    var cm = String(Math.max.apply(null, combo));
    var grid = $('[data-prods]');
    grid.innerHTML = '';
    D.products.forEach(function (p) {
      var v = p.v[cm];
      if (!v) return;
      var a = document.createElement('a');
      a.className = 'rv-calc__prod';
      a.href = p.u + (p.u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v[0];
      a.innerHTML = '<img loading="lazy" width="150" height="150" alt=""><span class="rv-calc__pt"></span><span class="rv-calc__pp"></span>';
      a.querySelector('img').src = p.i;
      a.querySelector('.rv-calc__pt').textContent = p.t;
      a.querySelector('.rv-calc__pp').textContent = fmtLen(+cm) + ' · ' + v[1];
      grid.appendChild(a);
    });
    $('[data-prods-wrap]').hidden = !grid.children.length;
  }

  function addRow(l, w, q) {
    nc++;
    var row = document.createElement('div');
    row.className = 'rv-calc__row';
    row.innerHTML = '<label><span></span><input type="number" min="1" max="2000" inputmode="numeric"></label>' +
      '<label><span></span><input type="number" min="1" max="2000" inputmode="numeric"></label>' +
      '<label class="rv-calc__q"><span></span><input type="number" min="1" max="50" value="1" inputmode="numeric"></label>' +
      '<button type="button" class="rv-calc__del"></button>';
    var sp = $$('span', row), inp = $$('input', row);
    sp[0].textContent = T.long; sp[1].textContent = T.wide; sp[2].textContent = T.qty;
    if (l) inp[0].value = l; if (w) inp[1].value = w; if (q) inp[2].value = q;
    var del = $('.rv-calc__del', row);
    del.textContent = '×'; del.setAttribute('aria-label', T.del);
    del.addEventListener('click', function () { row.remove(); update(); });
    $('[data-custom]').appendChild(row);
    inp[0].focus();
  }

  $$('.rv-calc__size').forEach(function (b) {
    b.addEventListener('click', function () {
      size = +b.dataset.size;
      $$('.rv-calc__size').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      update();
    });
  });
  root.addEventListener('change', update);
  root.addEventListener('input', function (e) { if (e.target.type === 'number') update(); });
  $('[data-add]').addEventListener('click', function () { addRow(); });
  /* Enlaces del tipo ?p=roof,hood desde guías y páginas: marcan esas piezas al abrir */
  var pre = new URLSearchParams(location.search).get('p');
  if (pre) pre.split(',').forEach(function (id) { var c = $('.rv-calc__part input[value="' + id + '"]'); if (c) c.checked = true; });
  update();
})();
